import * as React from 'react';
export const PerformanceUpArrow = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 12 13" fill="none" {...props}>
    <path fill="#2B7F65" d="M6 .528a6 6 0 100 12 6 6 0 100-12z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 .528c3.311 0 6 2.688 6 6 0 3.31-2.689 6-6 6s-6-2.69-6-6c0-3.312 2.689-6 6-6zm.865 4.364L2.729 9.027l.771.77 4.137-4.135v3.046h1.09V3.8H3.818v1.091h3.047z"
      fill="#DFECE8"
    />
  </svg>
);
